module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceProductRenderModule",
    "path": "front/piece-product-render.module"
  },
  "definition": {
    "type": "product",
    "name": "PieceProductDefinition",
    "group": "Components",
    "availablePlatforms": ["web"],
    "description": "Producto",
    "fields": [
      {
        "name": "productId",
        "label": "Product",
        "type": "product",
        "mandatory": true,
        "jsonPath": "product.productId"
      },
      {
        "name": "main",
        "type": "productSettingsSelector",
        "jsonPath": "main"
      },
      {
        "label": "Mostrar en producto",
        "type": "groupCollapsable",
        "flattenFields": true,
        "isFolded": true,
        "fields":[
        {
          "name": "displayProductName",
          "label": "Nombre",
          "type": "groupToggleable",
          "flattenFields": true,
          "fields": [
            {
              "name": "productName",
              "label": "Nombre del producto",
              "type": "richText"
            }
          ]
        },
        {
          "name": "displayProductDescription",
          "label": "Descripción",
          "type": "groupToggleable",
          "flattenFields": true,
          "fields": [
            {
              "name": "productDescription",
              "label": "Descripción del producto",
              "type": "richText"
            }
          ]
        },
        {
          "name": "prices",
          "label": "Precios",
          "type": "prices"
        },
        {
          "name": "displayProductAddToCart",
          "label": "Botón de 'Añadir al carro'",
          "type": "productPurchaseOptions"
        }
       ]
      },
      {

        "label": "Imagen",
        "type": "groupCollapsable",
        "flattenFields": true,
        "isFolded": true,
        "fields":[
        {
          "name": "extraImage",
          "label": "Añadir una imagen extra",
          "type": "groupToggleable",
          "flattenFields": true,
          "fields": [
            {
              "name": "extra",
              "type": "productSettingsSelector",
              "jsonPath": "extra"
            },
          ]
        },
       ]
      },
      { name: "productVariants", label: "Slides con variantes", type: "slidesSelector" },
    ]
  }
};
